import FormFeedbackBanner from "../forms/FormFeedbackBanner";
import { Camera, UserCircle } from "@phosphor-icons/react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useProfilePhotoPromptViewModel } from "./useProfilePhotoPromptViewModel";
import "./ProfilePhotoPrompt.css";

import ProfilePhotoCropper from "./ProfilePhotoCropper";

export default function ProfilePhotoPrompt() {
  const model = useProfilePhotoPromptViewModel();
  return <ProfilePhotoPromptContent model={model} />;
}

export function ProfilePhotoPromptContent({ model }: { model: ReturnType<typeof useProfilePhotoPromptViewModel> }) {
  return <>
    {model.showReminder && <aside className="profile-photo-reminder" aria-label="Profile photo reminder">
      <div><strong>Add a profile photo</strong><p>Help other racers recognise you.</p></div>
      <div className="profile-photo-reminder-actions">
        <Button onClick={model.open}>Add photo</Button>
        <Button variant="link" onClick={() => model.close(true)}>Dismiss reminder</Button>
      </div>
    </aside>}
    <Modal show={model.show} onHide={() => { if (!model.busy) model.close(); }} centered aria-labelledby="photo-setup-title">
      <Modal.Body className="profile-photo-setup">
        <p className="profile-photo-setup-eyebrow">Make it yours</p>
        <h2 id="photo-setup-title">Add a profile photo</h2>
        <p>Help other racers recognise you.</p>
        {model.selection && model.selection !== "google" && model.preview ?
          <ProfilePhotoCropper key={model.preview} image={model.preview} disabled={model.busy}
              onCrop={model.setCrop} onError={model.cropFailed} /> :
          <div className="profile-photo-setup-preview" role="img" aria-label="Profile photo preview">
            {model.preview ? <img src={model.preview} alt="" /> : <UserCircle size={136} weight="light" aria-hidden="true" />}
          </div>}
        <p className="profile-photo-setup-privacy">Your photo is visible to other racers on your profile and in race lists. You can change it later.</p>
        <input ref={model.inputRef} hidden type="file" accept="image/jpeg,image/png,image/webp"
          aria-label="Choose a profile photo" disabled={model.busy} onChange={(event) => { model.choose(event.target.files?.[0]); event.target.value = ""; }} />
        <Button variant={model.selection ? "outline-primary" : "primary"} disabled={model.busy} onClick={() => model.inputRef.current?.click()}>
          <Camera size={20} aria-hidden="true" /> {model.selection ? "Choose another photo" : "Choose photo"}
        </Button>
        {model.googlePhotoUrl && <Button variant="outline-secondary" disabled={model.busy} onClick={model.chooseGoogle}>Use my Google photo</Button>}
        <p className="profile-photo-setup-hint">JPG, PNG or WebP, up to 8 MB.</p>
        {model.error && <FormFeedbackBanner tone="error" messageKey={model.error}>{model.error}</FormFeedbackBanner>}
        {model.selection && <Button disabled={model.busy || !model.readyToSave} onClick={() => void model.save()}>
          {model.busy ? <><Spinner size="sm" aria-hidden="true" /> <span role="status">Saving photo...</span></> : "Save and continue"}
        </Button>}
        <Button variant="link" disabled={model.busy} onClick={() => model.close()}>Not now</Button>
      </Modal.Body>
    </Modal>
  </>;
}
